import {
  ADD_MEMBER_FIELD_LIMITS,
  focusNextField,
  sanitizeYearDigits,
  storageDateToYearDigits,
  yearDigitsToStorageDate,
} from "../../Utils/family-tree/addMemberFieldLimits";

/**
 * Year-only field (3 digits) — used for Year Divorced; stores YYYY/01/01 for date validators.
 */
export function AddMemberYearField({
  value,
  onChange,
  name,
  disabled = false,
  className = "",
  inputClassName = "form-control",
}) {
  const displayValue = storageDateToYearDigits(value);

  const handleChange = (e) => {
    const digits = sanitizeYearDigits(e.target.value);
    const storage = yearDigitsToStorageDate(digits);
    onChange({
      target: {
        name,
        value: storage,
        isValid: digits.length === ADD_MEMBER_FIELD_LIMITS.YEAR_DIGITS,
      },
    });
    if (digits.length >= ADD_MEMBER_FIELD_LIMITS.YEAR_DIGITS) {
      requestAnimationFrame(() => focusNextField(e.target));
    }
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      name={name}
      value={displayValue}
      onChange={handleChange}
      disabled={disabled}
      className={`addmember-year-field ${inputClassName} ${className}`.trim()}
      maxLength={ADD_MEMBER_FIELD_LIMITS.YEAR_DIGITS}
      autoComplete="off"
      placeholder="YYY"
      aria-label="Year (3 digits)"
    />
  );
}
